import router, { routesExceptions } from "@/router/index";
import {
  getConnectedUser,
  getCurrentSession,
  getGuardSystem,
  getGuardSystemPass,
} from "@/utils/localStorage";
import { checkSessionTokenRemainingTime } from "@/utils/sessionsDateTime";
import Vue from "vue";

const validatePermissions = (toRoute) => {
  const guardSystem = getGuardSystem();
  const guardSystemPass = getGuardSystemPass();

  if (guardSystem.key === guardSystemPass) {
    const userData = getConnectedUser();
    const sessionDataTime = getCurrentSession();
    const exceptions = routesExceptions();

    if (userData !== undefined && sessionDataTime !== undefined) {
      const checkUserLogged = userData.checkLogin;
      const checkSessionTime = checkSessionTokenRemainingTime();

      if (checkUserLogged && checkSessionTime) {
        const routePath = toRoute.path;
        const routerOptions = router.options;

        const routeData = routerOptions.routes.find(
          (route) => route.path === routePath
        );

        const checkExceptions = exceptions.some(
          (exception) => exception === routeData.permission
        );

        return checkExceptions
          ? true
          : userData.abilities.some(
              (ability) => ability === routeData.permission
            );
      }
    }
  }

  return "disconnected";
};

const validationRoute = (to, from, next) => {
  const statusPermission = validatePermissions(to);
  const { term_responsibility_flag } = getConnectedUser();
  const { path } = to;

  if (
    statusPermission &&
    !term_responsibility_flag &&
    path !== "/visualizar-termo"
  ) {
    next("/visualizar-termo");
    return;
  }

  switch (statusPermission) {
    case true:
      next();
      break;

    case "disconnected":
      next("/");
      Vue.prototype.$snackbar.setParams(
        "warning",
        "Usuário desconectado",
        "Realize o login novamente para ter acesso ao sistema."
      );
      break;

    default:
      next("/acesso-rapido");
      Vue.prototype.$snackbar.setParams(
        "warning",
        "Permissão negada",
        "Você não tem permissão para acessar este recurso."
      );
      break;
  }
};

export default validationRoute;
